import React from "react";
import { Box, Container, Image, Title } from "@mantine/core";
import { useParallax } from "@/hooks/useParallax";
import styles from "./HeaderContainer.module.scss";
import { GreenWaves } from "./GreenWaves";

export const TitleContainer = ({ children, ...rest }: { children: React.ReactNode }) => {
	return (
		<Container py={25} ta='center' c='#003640' {...rest}>
			{
				typeof children === "string" ? (
					<ThemedTitle size={28}>{children}</ThemedTitle>
				) : (
					children
				)
			}
		</Container>
	);
};

type ImageContainerProps = {
	children: React.ReactNode,
	imageUrl: string,
	c?: string,
	style?: React.CSSProperties,
	parallax?: boolean,
	parallaxSpeed?: number
};

export const ImageContainer = ({
	children,
	imageUrl,
	c = "#003640",
	style,
	parallax = false,
	parallaxSpeed = 0.5,
	...rest
}: ImageContainerProps) => {
	const parallaxOffset = useParallax(parallaxSpeed);
	return (
		<Box
			pos={"relative"}
			w='full'
			className={[styles.imageContainer, parallax ? styles.parallaxContainer : ''].join(' ')}
			style={{
				backgroundImage: `url("${imageUrl}")`,
				backgroundColor: "#EBFDF5",
				transform: parallax ? `translateY(${parallaxOffset}px)` : undefined,
				...style,
			}}
		>
			<Box
				className={styles.gradientContainer}
				{...rest}
			>
				<Container py={50} c={c}>
					{children}
				</Container>
			</Box>
			<GreenWaves />
		</Box>
	);
};

export const ThemedTitle = Title.withProps({
	c: "themed-black.8",
});